// ----------------------------------------------------------------------------
// Component: Content Cards
// ----------------------------------------------------------------------------
//
// Section displaying a default card consisting of an image,
// title, content and button. It displays a 1, 2 or 3 column grid.
//
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------
import Swiper, { Scrollbar, A11y, Keyboard } from 'swiper';
import 'snippets/card/card';
import 'snippets/icon/icon';

// Style includes
import 'swiper/css';
import 'swiper/css/scrollbar';
import 'swiper/css/a11y';
import 'swiper/css/keyboard';
import './_content-cards.scss';


// -------------------------------------
// Variables
// -------------------------------------
const CAROUSEL_SELECTOR = '.carousel--content-cards';
const CAROUSEL_CLASS = 'carousel--content-cards';
const CAROUSEL_SECTION_SELECTOR = '.content-cards';
const CAROUSEL_SECTION_CLASS = 'content-cards';
const CAROUSEL_SCROLLBAR_SELECTOR       = '.swiper-scrollbar';


// -------------------------------------
// Hooks
// -------------------------------------
const elements = {
    contentCardsCarousel: null
};

const breakpoint = window.matchMedia( '(min-width:768px)' );
const createCarousel = (element, index) => {
    // Generate unique class for each collection list slider
    element.querySelector(CAROUSEL_SELECTOR).classList.add(`${CAROUSEL_CLASS}-${index}`);

    // Generate unique btn classes for slider arrows
    element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).classList.add(`${CAROUSEL_SECTION_CLASS}-scrollbar-${index}`);
    const scrollbar = element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR);

    elements.contentCardsCarousel = new Swiper(`.${CAROUSEL_CLASS}-${index}`, {
        // Optional parameters
        modules: [Scrollbar, A11y, Keyboard],
        slidesPerView: 1.1,
        spaceBetween: 10,
        centerInsufficientSlides: true,
        observer: true,
        observeParents: true,
        a11y: false,
        watchOverflow: true, // Do not turn into sliders if number of slides is less than slidesPerView.
        grabCursor: true,

        breakpoints: {
            0: {
                slidesPerView: 1.2264,
                spaceBetween: 13.66,
            },
            768: {
                slidesPerView: 3,
                spaceBetween: 20,
            }
        },
        scrollbar: {
            el: scrollbar,
            draggable: true,
        }
    });


    elements.contentCardsCarousel.slides.forEach(function(slide, index) {
        const slideLink = slide.querySelector('a');
        slideLink?.addEventListener('focus', function() {
            elements.contentCardsCarousel.slideTo(index);
        });
    });
};
document.querySelectorAll(CAROUSEL_SECTION_SELECTOR)
    .forEach((element, index) => {

        const checkBreakpoint = function(element) {
            if ( breakpoint.matches === true ) {
                // If the viewport is 680px or wider
                // Replace swiper-slide class with css-grid__item card card--default
                element.querySelectorAll('.swiper-slide').forEach(function(slide) {
                    slide.classList.remove('swiper-slide');
                });

                // Hide the scrollbar
                element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).style.display = 'none';

                // Destroy the carousel if it exists
                if ( elements.contentCardsCarousel !== null ) {
                    elements.contentCardsCarousel.destroy( true, true );
                }

            } else if ( breakpoint.matches === false ) {
                // If the viewport is 679px or narrower
                // Replace css-grid__item card card--default classes with swiper-slide
                element.querySelectorAll('.css-grid__item').forEach(function(slide) {
                    slide.classList.add('swiper-slide');
                });

                // Show the scrollbar
                element.querySelector(CAROUSEL_SCROLLBAR_SELECTOR).style.display = 'block';

                // Create the carousel
                createCarousel(element, index);

            }
        };
        breakpoint.addEventListener('change', () => checkBreakpoint(element));
        checkBreakpoint(element);

    });
